module.exports = {"lastBuildTimeStamp":1670925409703}


//////////////////
// WEBPACK FOOTER
// ./static/version.json
// module id = c+VB
// module chunks = 18